module.exports = __webpack_public_path__ + "static/media/pacing-large.3161b132.png";